const locale = `

# ***********************************************
# FAQ
# ***********************************************
faq = Часто Задаваемые Вопросы
faq_text = Часто Задаваемые Вопросы

  Если у вас есть другие вопросы, вы можете обратиться в нашу службу поддержки.
  Используйте команду /help чтобы получить ссылку на чат поддержки.

  Пожалуйста, выберите ваш вопрос:
faq_not_found = Вопрос или ответ не найден

faq_why_choose_question = Почему стоит выбрать вашу карту?
faq_why_choose_button = Почему стоит выбрать вашу карту?
faq_why_choose_answer = Выбор всегда за Вами, но у нас есть несколько преимуществ перед любыми другими сервисами:

  1. Низкие комиссии за пополнение: наши комиссии значительно ниже, чем у конкурентов.
  2. Отсутствие скрытых платежей: комиссии за покупки 0%, бесплатная конвертация токенов и уведомления.
  3. Мы и сами постоянно пользуемся нашими картами и знаем что еще предстоит улучшить.
  4. Человеческий подход: никаких скриптов и бюрократии, мы всегда готовы помочь, выслушать ваши предложения или замечания и реализовать хорошие идеи!

faq_how_to_get_question = Как получить карту?
faq_how_to_get_button = Как получить карту?
faq_how_to_get_answer = Чтобы получить виртуальную карту вам нужно только купить её через нашего бота.

  1. В чате с ботом откройте меню команд и используйте команду /virtualcard для оформления заказа.
  2. Выберите подходящий вам тарифный план (отличие в стоимости выпуска и комиссии за пополнение).
  3. Выполните соответствующий тарифу перевод USDT в сети TRON (TRC20) на указанный адрес кошелька (адрес копируется при клике по нему).
  4. Ваша карта будет выпущена сразу после подтверждения транзакции и будет действительна в течение 5 лет.

  ⚠️ При высоком спросе на карты время выпуска может увеличиться до 24 часов.

faq_how_to_top_up_question = Как пополнить карту?
faq_how_to_top_up_button = Как пополнить карту?
faq_how_to_top_up_answer = Чтобы пополнить виртуальную карту вам нужно выполнить следующие шаги:

  1. В чате с ботом откройте меню команд и используйте команду /topup.
  2. Выполните перевод USDT в сети TRON (TRC20) на указанный адрес кошелька (адрес копируется при клике по нему).
  3. При достаточной сумме перевода комиссия за пополнение спишется автоматически, а остальная сумма будет зачислена на выбранную карту.
  4. После зачисления средств на баланс карты вы получите уведомление в чате с ботом.

  Условия пополнения:  
  Минимальная сумма пополнения:
  - Виртуальные карты: 25 USDT для всех тарифов.
  - Физические карты: 35 USDT для всех тарифов.

  Фиксированная комиссия: 10 USDT для всех тарифов.  
  Переменная комиссия: зависит от выбранного тарифа карты (1%-2% от суммы пополнения).  

  ⚠️ Фиксированная комиссия в 10 USDT взимается в связи с необходимостью покупки TRX для дальнейших переводов токена, требуемых для работы сервиса.
  При значительном изменении курса TRX к USDT, комиссия может быть пересмотрена.
  Это может также повлиять на минимальную сумму пополнения карты.

faq_cards_number_question = Сколько карт я могу иметь?
faq_cards_number_button = Сколько карт я могу иметь?
faq_cards_number_answer = В настоящее время автоматический быстрый выпуск поддерживает только 1 карту.

  Дополнительные карты потребуют ручного одобрения нашей службы поддержки.
  Мы работаем над тем, чтобы снять это ограничение и упростить использование нашего сервиса.

faq_wallets_question = Как добавить карту в Apple Pay или Google Wallet?
faq_wallets_button = Как добавить карту в Apple Pay или Google Wallet?
faq_wallets_answer = ✅ Google Wallet: Вы можете добавить карту и сразу начать ее использование.

  ⚠️ Apple Pay:
  Виртуальные и физические карты, купленные до 19 августа 2025 года можно добавлять без проблем.
  Виртуальные карты, выпущенные в юрисдикции Гонконг, купленные после 19 августа 2025 года нельзя добавить в Apple Pay.

  ❗️ По независящим от нас причинам виртуальные карты, выпущенные в юрисдикции Гонконг, не могут быть добавлены в Apple Pay после 19 августа 2025 года.
  Мы работаем над выпуском виртуальных карт в других юрисдикциях и постараемся решить эту проблему в течение ближайшего месяца.

  Верификация карты:
  При добавлении карты всегда выбирайте Email в качестве варианта верификации!
  Не нужно использовать свой личный email.
  Код подтверждения OTP будет автоматически доставлен в нашу систему и показан прямо в боте.
  Вам нужно только дождаться сообщения с подтверждением — ручной ввод не требуется.

  Наша рекомендация:
  Если вы пользователь iOS, мы рекомендуем иметь небольшое недорогое Android-устройство в качестве резерва.
  Это гарантирует, что у вас всегда будет доступ к Google Wallet, который полностью поддерживает все карты.

faq_paypal_question = Как добавить карту в PayPal?
faq_paypal_button = Как добавить карту в PayPal?
faq_paypal_answer = Чтобы добавить карту в PayPal, выполните следующие шаги:
  Перейдите в ваш PayPal Кошелек → Привязать карту.
  Введите данные вашей карты.
  В боте нажмите Подтвердить.
  Дождитесь сообщения с подтверждением.
  Если не получается, повторяйте процесс подтверждения до успешного завершения.

faq_safety_question = Безопасно ли использовать эти карты?
faq_safety_button = Безопасно ли использовать эти карты?
faq_safety_answer = Да, это полностью безопасно.

  Все данные держателей карт зашифрованы и надежно хранятся.  
  Только конечный клиент имеет доступ к конфиденциальным данным.

faq_kyc_question = KYC (Знай своего клиента) – Когда это необходимо?
faq_kyc_button = KYC (Знай своего клиента)
faq_kyc_answer = Обычно никаких документов не требуется.

  В случае подозрительной или высокорисковой активности мы можем запросить:  
  - Копию паспорта/удостоверения личности
  - Подтверждение адреса

  Этот процесс обеспечивает безопасность всех пользователей.

faq_recurring_payments_question = Предупреждение о повторяющихся платежах
faq_recurring_payments_button = ❗️ Повторяющиеся платежи
faq_recurring_payments_answer = Не связывайте свою карту с сервисами, которые могут создавать частые повторяющиеся платежи одной и той же суммы!

  Это не касается обычных месячных или недельных подписок, которые не вызывают подозрений у службы безопасности банка.  
  Однако множественные идентичные списания в течение суток могут вызвать проблемы.

  Это особенно важно при оплате рекламы в Facebook и Google.

  Множественные идентичные списания с одного и того же продавца могут вызвать временные блокировки карты службой безопасности банка эмитента карты.  
  В случае блокировки карты вам может потребоваться подтвердить свою личность и источник средств для банка через нашу службу поддержки.  
  Разблокировка вашей карты может занять до 30 дней в зависимости от скорости работы поддержки банка.

  Чтобы избежать проблем:
  - Всегда пополняйте баланс своего аккаунта заранее.
  - Варьируйте суммы и частоту транзакций.

  Для вашей безопасности:
  - Не храните большие суммы на своей карте (блокчейн почти всегда надежнее банка).
  - Пополняйте карту только в соответствии с вашими фактическими расходами.

  Эти меры направлены на защиту вас от мошенничества и перебоев в обслуживании.

faq_aml_question = Политика AML (Противодействие отмыванию денег)
faq_aml_button = Политика AML (Противодействие отмыванию денег)
faq_aml_answer = Противодействие отмыванию денег и информирование об этом юридически обязательно для работы нашей системы.  
  Использование карты для любой преступной, мошеннической или высокорисковой деятельности строго запрещено.

  🚫 Запрещенные действия:
  - Отмывание денег любого рода
  - Финансирование терроризма или экстремистских организаций
  - Проведение мошеннических схем, обмана или схем Понци
  - Использование украденной, взломанной или незаконно полученной криптовалюты
  - Транзакции, связанные с даркнет-рынками, наркотиками, оружием или незаконными услугами
  - Скрытие или «слоение» средств для маскировки их источника

  🔍 Мониторинг операций:
  - Каждая транзакция автоматически контролируется нашей системой.
  - Подозрительная активность приведет к немедленному приостановлению карты.
  - Крупные или необычные транзакции могут быть задержаны для ручной проверки.
  - Власти могут быть уведомлены, если будет обнаружена незаконная деятельность.

  ⚖️ Последствия за нарушения:
  - Карты, использованные для преступной деятельности, будут заблокированы навсегда.
  - Все средства, полученные преступным путем, будут конфискованы и возвращены законным владельцам или властям.
  - Возврат средств за комиссии, уплаченные нарушителями, не будет произведен.
  - Повторные правонарушители будут навсегда исключены из наших услуг.

  ✅ Ваша ответственность:
  - Всегда используйте только легитимные средства.
  - Убедитесь, что ваши пополнения поступают из прозрачных и законных источников.
  - Понимайте, что, используя наш сервис, вы соглашаетесь на полное соблюдение AML.

# ***********************************************
# Landing Page
# ***********************************************

# Hero Section
hero_title = Международные платежи снова доступны
hero_subtitle = Получите виртуальную карту Visa, которая работает без ограничений.
  Оплачивайте зарубежные сервисы и свободно путешествуйте, пополняя баланс в USDT
hero_button = Подобрать карту

# Problem Section
problem_title = Знакомая ситуация?
problem_subtitle = Когда привычные карты больше не работают, нужно надежное решение.
problem_item_1 = Российскую карту Visa/Mastercard не принимают за границей
problem_item_2 = Сложно оплатить подписки на привычные зарубежные сервисы и покупки
problem_item_3 = Во время отпуска приходится носить наличные и искать обменники
problem_conclusion = Наша карта, пополняемая в криптовалюте, решает эти проблемы.
  Это ваш личный финансовый инструмент, который
problem_conclusion_highlight = не зависит ни от санкций, ни от банковской системы РФ или стран запада.

# Use Cases Section
usecases_title = Где пригодится карта?
usecases_payment_title = Оплата зарубежных сервисов
usecases_payment_desc = Верните доступ к привычным сервисам: Adobe, Figma, Steam, Spotify, Netflix, Booking и другим
usecases_travel_title = Свободные расчеты в поездках
usecases_travel_desc = Путешествуйте без пачки наличных. Платите картой в отелях, ресторанах и магазинах в любой стране мира
usecases_ads_title = Рекламные компании и кабинеты
usecases_ads_desc = Стабильная оплата рекламы в Google, TikTok, Facebook, без риска блокировки личной карты

# Stability Section
stability_title = Стабильность в нестабильные времена
stability_subtitle = Защитите свои сбережения от волатильности курса и инфляции
stability_reliability_title = Надежность
stability_reliability_desc = Ваши сбережения привязаны к доллару США (USDT) и максимально защищены от инфляции и колебаний курса.
stability_security_title = Безопасность
stability_security_desc = Риск блокировки активов в криптовалюте значительно ниже, чем на банковских счетах.
stability_access_title = Мгновенный доступ
stability_access_desc = В любой момент переводите нужную сумму с криптокошелька на карту и пользуйтесь ей.
stability_predictability_title = Предсказуемость
stability_predictability_desc = Пользуйтесь картой с заранее известными комиссиями на протяжении всего срока действия до 2030 года.

# Pricing Section
pricing_title = Прозрачные условия и тарифы
pricing_subtitle = Выберите тариф, который подходит именно вам.
pricing_popular = Самый популярный

pricing_start_title = Старт 🚀
pricing_start_price = 120 USDT
pricing_start_fee = Комиссия за пополнение: 2% + 10 USDT
pricing_start_no_tx_fee = Нет комиссии за транзакции
pricing_start_small_expenses = Идеально для небольших трат
pricing_start_basic_support = Базовая поддержка

pricing_balance_title = Баланс ⚖️
pricing_balance_price = 240 USDT
pricing_balance_fee = Комиссия за пополнение: 1.5% + 10 USDT
pricing_balance_no_tx_fee = Нет комиссии за транзакции
pricing_balance_optimal = Оптимальный выбор для регулярного использования
pricing_balance_priority_support = Приоритетная поддержка

pricing_premium_title = Премиум 💎
pricing_premium_price = 360 USDT
pricing_premium_fee = Комиссия за пополнение: 1% + 10 USDT
pricing_premium_no_tx_fee = Нет комиссии за транзакции
pricing_premium_large_payments = Для крупных платежей и рекламных бюджетов
pricing_premium_priority_support = Приоритетная поддержка

pricing_one_time_fee = разовая плата за выпуск
pricing_select_button = Выбрать
pricing_footer_note = Это **разовая плата** за выпуск вашего финансового инструмента, который будет действовать до 2030 года.
  Полезная инвестиция в вашу финансовую свободу и независимость.

# Final CTA Section
final_cta_title = Ваш независимый доступ к глобальным платежам
final_cta_subtitle = Начните пользоваться криптовалютой в реальном мире уже сегодня.
  Процесс выпуска карты займет всего несколько минут.
final_cta_button = Выбрать свой тариф

# ***********************************************
# Header & Footer
# ***********************************************

# Header
header_features = Возможности
header_pricing = Тарифы
header_telegram_bot = TELEGRAM BOT

# Footer
footer_title = UCard Bot | Crypto Visa Cards
footer_subtitle = Ваш мост между криптовалютой и реальным миром.
footer_privacy_policy = Политика конфиденциальности
footer_terms_of_service = Условия использования
footer_aml_policy = AML-политика
footer_contact_us = Связаться с нами
footer_telegram_label = Telegram:
footer_copyright = UCard, 2025

`;

export default locale;
